export const GRAPHQL_URL_LOCAL = "http://localhost:4000/graphql";
export const TERMSANDCONDITION = "https://www.omnioutreach.com/";
export const PRIVACYPOLICY = "https://www.omnioutreach.com/";
export const IMAGE_URL = process.env.REACT_APP_NODE_ENV
  ? "https://agencyflashdev.nyc3.digitaloceanspaces.com/"
  : "http://localhost:4000/";

export const GMAIL_REDIRECT_URL = process.env.REACT_APP_NODE_ENV
  ? `${process.env.REACT_APP_GMAIL_REDIRECT_URL}/settings/email-provider`
  : "http://localhost:4001/settings/email-provider";

export const OAUTH_CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID;
 

 

// export const OAUTH_CLIENT_ID = process.env.REACT_APP_NODE_ENV
//   ? "888536774396-q5631dta2o0r3p4vg4rm9t6qgejs85ir.apps.googleusercontent.com"
//   : "871089372482-imbj253aucu0ae2970lnug79bs6uu1oi.apps.googleusercontent.com";

